import { useState } from "react";
import { Stack, Group, Divider } from "@mantine/core";
import { CustomSwitch } from "../../../ui/CustomSwitch/CustomSwitch";
import CustomButton from "../../../ui/CustomButton/CustomButton";
import { SummaryRow } from "../../../shared/result/ResultPrimitives";

const BankAccountStep2 = ({
  verifiedData,
  handleSave,
  isSaving,
  goBackToStep1,
}) => {
  const [isDefaultPayout, setIsDefaultPayout] = useState(false);

  const { accountName, bankName, accountNumber, swiftCode, branchCode } =
    verifiedData;

  return (
    <Stack style={{ flex: 1 }}>
      <div className="w-full rounded-xl border border-gray-200 bg-gray-50 p-4">
        <p className="text-xs text-center font-semibold text-gray-500 uppercase tracking-wide mb-3">
          Account Details
        </p>
        <SummaryRow label="Account Name" value={accountName} />
        <SummaryRow label="Bank Name" value={bankName} />
        <SummaryRow label="Account Number" value={accountNumber} stacked />
        <SummaryRow label="SWIFT Code" value={swiftCode} />
        <SummaryRow label="Branch Code" value={branchCode} />
      </div>
      <Divider />

      <CustomSwitch
        checked={isDefaultPayout}
        onChange={(e) => setIsDefaultPayout(e.currentTarget.checked)}
        activeLabel="Default Payout Method"
        inactiveLabel="Set as Default Payout Method"
        color="primary"
        disabled={isSaving}
      />

      <Group justify="flex-end" mt="auto">
        <CustomButton
          variant="default"
          onClick={goBackToStep1}
          disabled={isSaving}
        >
          Back
        </CustomButton>
        <CustomButton
          onClick={() => handleSave({ isDefaultPayout })}
          loading={isSaving}
          disabled={isSaving}
        >
          Add Bank Account
        </CustomButton>
      </Group>
    </Stack>
  );
};

export default BankAccountStep2;
